module.exports = __webpack_public_path__ + "img/onboarding-step-1.04aa28a5.png";